import $ from "jquery";
import App from "./app";

$(window).on("load", function () {
  const app = new App();
  $("html").addClass("loaded");

  if ($("#job-form").length) {
    window.renderRecaptcha(
      "job-recaptcha",
      this.jobCallback,
      this.expiredJobCallback
    );
  }

  if ($("#switch-form").length) {
    window.renderRecaptcha(
      "switch-recaptcha",
      this.switchCallback,
      this.expiredSwitchCallback
    );
  }
});

var contactRecaptcha, signupRecaptcha, jobRecaptcha, switchRecaptcha;

window.renderRecaptcha = function (id, callback, recaptchaExpired) {

  if (id == "signup-recaptcha") {
    signupRecaptcha = grecaptcha.render(id, {
      sitekey: Syngency.recaptcha_site_key,
      theme: "light",
      callback: callback,
      "expired-callback": recaptchaExpired,
    });
  }

  if (id == "job-recaptcha") {
    jobRecaptcha = grecaptcha.render(id, {
      sitekey: Syngency.recaptcha_site_key,
      theme: "light",
      callback: callback,
      "expired-callback": recaptchaExpired,
    });
  }

  if (id == "switch-recaptcha") {
    switchRecaptcha = grecaptcha.render(id, {
      sitekey: Syngency.recaptcha_site_key,
      theme: "light",
      callback: callback,
      "expired-callback": recaptchaExpired,
    });
  }

  if (id == "contact-recaptcha") {
    contactRecaptcha = grecaptcha.render(id, {
      sitekey: Syngency.recaptcha_site_key,
      theme: "light",
      callback: callback,
      "expired-callback": recaptchaExpired,
    });
  }
};

window.recaptchaResponse = function (id) {
  var response;
  switch (id) {
    case "signup-recaptcha":
      response = grecaptcha.getResponse(signupRecaptcha);
      break;

    case "job-recaptcha":
      response = grecaptcha.getResponse(jobRecaptcha);
      break;

    case "switch-recaptcha":
      response = grecaptcha.getResponse(switchRecaptcha);
      break;

    case "contact-recaptcha":
      response = grecaptcha.getResponse(contactRecaptcha);
      break;
  }
  return response;
};

window.resetRecaptcha = function (id) {
  switch (id) {
    case "signup-recaptcha":
      grecaptcha.reset(signupRecaptcha);
      break;

    case "job-recaptcha":
      grecaptcha.reset(jobRecaptcha);
      break;

    case "switch-recaptcha":
      grecaptcha.reset(switchRecaptcha);
      break;

    case "contact-recaptcha":
      grecaptcha.reset(contactRecaptcha);
      break;
  }
};

window.rendered = false;
